export default __webpack_public_path__ + "static/media/new-dashboard.375bc508.svg";